<table
  *ngIf="dataSource"
  cdk-table
  [dataSource]="dataSource"
  [multiTemplateDataRows]="true"
  class="generic-data-table sd-table"
>
  @for (headRow of table.headers; track headRow) {
    @for (header of headRow; track header.column) {
      @if (header | validRegularHeader) {
        <!-- Generated Column Definition -->
        <ng-container
          [cdkColumnDef]="header | tableHeaderToCdkTableColumn">
          <th
            class="sd-table-cell sd-table-cell--bg-neutral-100"
            cdk-header-cell
            *cdkHeaderCellDef
            [appAlign]="table.meta[header.column]?.align"
            [appRowspan]="header.rowspan"
            [appColspan]="header.colspan"
          >
            <app-table-header
              [header]="header"
              [sorter]="sorter"
              [unsortable]="table.meta[header.column]?.unsortable"
            />
          </th>

          <td
            class="sd-table-cell"
            cdk-cell
            *cdkCellDef="let element"
            [appAlign]="table.meta[header.column]?.align"
            [appRowspan]="header.rowspan"
          >
            <app-table-cell
              [data]="element.content[header.column]"
              [meta]="table.meta[header.column]"
              [row]="element"
            />
          </td>
        </ng-container>
      }
    }
  }

  <!-- Column with empty cells and empty header -->
  <ng-container cdkColumnDef="_blank_">
    <th class="sd-table-cell sd-table-cell--bg-neutral-100" cdk-header-cell *cdkHeaderCellDef></th>
    <td class="sd-table-cell" cdk-cell *cdkCellDef="let element"></td>
  </ng-container>

  <!-- Column with empty cells -->
  <ng-container cdkColumnDef="_placeholder_">
    <th class="sd-table-cell sd-table-cell--bg-neutral-100" cdk-header-cell *cdkHeaderCellDef hidden></th>
    <td class="sd-table-cell" cdk-cell *cdkCellDef="let element"></td>
  </ng-container>

  <!-- Seperator Column -->
  <ng-container cdkColumnDef="hr">
    <th cdk-header-cell *cdkHeaderCellDef [attr.colspan]="table.headers[0].length" class="seperator" aria-hidden="true">
    </th>

    <td cdk-cell *cdkCellDef="let element" [attr.colspan]="table.headers[0].length" class="seperator" aria-hidden="true">
    </td>
  </ng-container>

  <thead>
    <tr cdk-header-row *cdkHeaderRowDef="['hr']"></tr>

    <!-- Generated Headers -->
    @for (tableHeaderDefsRow of table.headers; track $index) {
      <tr
        cdk-header-row
        *cdkHeaderRowDef="tableHeaderDefsRow | tableHeaderDefsRowToCdkTableColumns"
        [class.first]="$first"
        [class.last]="$last"
      ></tr>

    }

    <tr cdk-header-row *cdkHeaderRowDef="['hr']"></tr>
  </thead>

  <tbody>
    <!-- Generated Rows -->
    @for (tableHeaderDefsRow of table.headers; track tableHeaderDefsRow) {
      <tr
        cdk-row
        *cdkRowDef="let row; columns: tableHeaderDefsRow | tableHeaderDefsRowToCdkTableColumns"
        [class.first]="$first"
        [class.last]="$last"
        [class.collapse]="row.hiddenBySearch"
      ></tr>
    }

    <!-- Seperator Row -->
    <tr cdk-row *cdkRowDef="let row; columns:['hr']; when: isSeperatorVisible" [attr.hidden]="(row.hiddenBySearch && !row.isGroupHeader) ? true : null"></tr>
  </tbody>
</table>

@if (table) {
  @if (searcher.allHiddenBySearch) {
    <ng-content select="[no-results]"></ng-content>
  } @else if (table.rows.length < 1) {
    <ng-content select="[empty]"></ng-content>
  }
}
